import { Box, Callout } from '@radix-ui/themes'
import { useOutletContext } from '@remix-run/react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { RxInfoCircled } from 'react-icons/rx'

import { appConfig } from '~/app-config.ts'
import { CART_I18NEXT } from '~/routes/($lang).cart/cart.component'
import { type Context } from '~/routes/_layout/root.component'

/* -------------------------------------------------------------------------------------------------
 * Header
 * -----------------------------------------------------------------------------------------------*/

const Header: React.FC = () => {
	const { locale } = useOutletContext<Context>()
	const { t } = useTranslation(CART_I18NEXT.routeCart)

	return (
		<Box asChild position="sticky" top="0" pb="1">
			<header>
				<Callout.Root color="green">
					<Callout.Icon>
						<RxInfoCircled size="1.2em" />
					</Callout.Icon>
					<Callout.Text weight="medium">
						{t('header.common.info-$val', {
							val: appConfig.free_shipping / 100,
							currency: appConfig.currency,
							locale: locale,
						})}
					</Callout.Text>
				</Callout.Root>
			</header>
		</Box>
	)
}
Header.displayName = 'Header'

/* -----------------------------------------------------------------------------------------------*/

export { Header }
